import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { Skeleton } from 'src/common';
import {
  TenderCatName,
  isFieldString,
  TenderBoxMode,
  TenderBlockSize,
  showField
} from 'src/models/procurements/Tender/types';
import GeneralCat from '../CatGeneral';
import { TenderBox, TenderCat, TenderSubCat } from 'src/shared';
import CatQAndA from '../CatQAndA';
import ProcurementFiles from '../ProcurementFiles';
import DocumentSearch from '../DocumentSearch';
import classNames from 'classnames';
import TenderSidebar from '../TenderSidebar';
import { useLocation } from 'react-router-dom';

export const TenderContent: FC = () => {
  const { data, loading } = useTenderData();
  const docsCat = data?.docsCat;
  const id = data?.id;
  const files = useMemo(
    () => (docsCat ? { fileCategories: docsCat.fileCategories, filesAmount: docsCat.filesAmount } : undefined),
    [docsCat]
  );
  const cats = useMemo(() => (data ? data.cats : []), [data]);
  const name = useMemo(
    () => (data?.name && isFieldString(data.name.firstField) ? data.name.firstField.string : undefined),
    [data]
  );

  const { hash } = useLocation();
  const currentHash = useMemo(() => (!!hash ? hash.slice(1) : null), [hash]);
  const editable = !!data?.isEditable;

  return loading ? (
    <Skeleton active loading className={classNames(styles.loader, styles.content)} />
  ) : (
    <>
      {currentHash !== TenderCatName.KeywordSearch && (
        <>
          <GeneralCat />
          {!!cats.length &&
            cats.map(cat =>
              cat.id === 'ADDITIONS_AND_QA' ? (
                <CatQAndA cat={cat} key={cat.id} />
              ) : (
                <TenderCat cat={cat} key={cat.id}>
                  {!!cat.subCats.length &&
                    cat.subCats.map(subCat => (
                      <TenderSubCat subCat={subCat} key={subCat.id} boxTheme={false} className={styles.subCat}>
                        {!!subCat.boxes.length &&
                          subCat.boxes.map(box =>
                            box.fields.some(f => showField(f)) ? (
                              <TenderBox
                                box={box}
                                key={box.id}
                                as={TenderBoxMode.Base}
                                size={TenderBlockSize.ThreeQuarters}
                                editable={editable}
                                boxMode={editable}
                                isEditable={editable}
                                className={styles.box}
                                hideEmpty={true}
                              />
                            ) : null
                          )}
                      </TenderSubCat>
                    ))}
                </TenderCat>
              )
            )}
          {docsCat && files && (
            <div className={styles.tenderFilesContainer}>
              <TenderCat cat={docsCat} key={docsCat.id}>
                <div className={styles.procurementFilesContainer}>
                  <ProcurementFiles
                    procurementFiles={files}
                    procurementName={name || ''}
                    procurementId={id || ''}
                    linkToDocsSource={docsCat.linkToDocsSource}
                    bidId={data.bid?.id}
                  />
                </div>
              </TenderCat>
            </div>
          )}
        </>
      )}
      {currentHash === TenderCatName.KeywordSearch && files && (
        <DocumentSearch procurementFiles={files} procurementId={id || ''} />
      )}
      <TenderSidebar />
    </>
  );
};

export default TenderContent;
